import { Link } from "react-router-dom";

export const MentionText = ({ text }) =>
  String(text || "").split(/(@[a-zA-Z0-9_]{3,24})/g).map((p, i) =>
    p[0] === "@" && p.length > 3
      ? <Link key={i} to={`/u/${p.slice(1).toLowerCase()}`} onClick={(e) => e.stopPropagation()} data-testid={`mention-link-${p.slice(1).toLowerCase()}`} className="text-[#4599FF] hover:underline font-medium">{p}</Link>
      : <span key={i}>{p}</span>
  );
